import { firebaseImpl as fireBase, AUTH_URL } from '../../firebase/firebase';
import { authenticate, currentUser } from '../../components/auth/auth-provider';
import { message } from 'antd';
import qs from 'querystring';
import empresaDB from '../../dataManager/dtmEmpresa';


async function authUser(login, password) {

  return new Promise((resolve, reject) => {

    const url = AUTH_URL;

    fetch(url, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/x-www-form-urlencoded;charset=UTF-8'
      },
      body: qs.stringify({
        login,
        password,
      })
    }).then((response) => response.json())
      .then((responseData) => {
        if (responseData.code === 200) {
          resolve(responseData);
        }
        else {
          reject(responseData);
        }
      });
  });
}

export async function autenticar(login, password) {
  return new Promise((resolve) => {
    authUser(login, password)
      .then(resp => {
        fireBase.auth().signInWithCustomToken(resp.token)
          .then(async () => {
            // ─── `setores` e `ativo` agora vêm do servidor ─────────────────
            //
            // Aqui havia `empresaDB.getByLogin(login)`, uma consulta a
            // `empresas` por `login.login` feita só para pegar esses dois
            // campos. Ela é a única consulta do quiosque que NÃO tem como ser
            // filtrada por conta — é justamente ela que descobre de qual conta
            // a loja é. Enquanto existisse, `empresas` não poderia ser fechada
            // nas regras sem derrubar o login de todas as lojas.
            //
            // `POST /authUser` já lia esse documento para conferir a senha, e
            // agora devolve os dois campos junto. Ver functions/api/authentication.js.
            //
            // A checagem de `ativo` continua aqui por segurança de tela, mas
            // deixou de ser a única: o servidor agora recusa a loja desativada
            // com 403 e NÃO emite token — antes ele emitia, e só esta linha de
            // JavaScript separava uma loja desativada de uma sessão válida.
            if (resp.user.ativo === false) {
              message.error('Loja desativada. Contate o administrador.');
              resolve(false);
              return;
            }

            authenticate(resp.user);
            resolve(true);
          })
          .catch(error => {
            const msg = error.code === 'auth/user-disabled' ?
              'Senha ou email incorretos. Verifique.' :
              `Houve um erro inesperado. ${error.code} - ${error.message}`;

            message.error(msg);
            resolve(false);
          });
      })
      .catch(err => {
        message.error(err.message);
        resolve(false);
      });
  });

}

export async function redirectJustIfUserIsAuthenticated(history) {
  const user = await currentUser();
  if (user) {
    history.push('/fila');
  }
}

export async function updatePassword(id, password) {
  const empresa = await empresaDB.getById(id);
  if (!empresa) {
    return false;
  }
  empresa.login.password = password;
  await empresaDB.update(id, empresa);
  return true;
}
